class DropdownNav {
    constructor() {
        this.navul = document.querySelector('.top-nav-ul');
        this.openMenu = document.getElementById('open-menu');
        this.events();
    }


    events() {
        this.openMenu.addEventListener('click', this.menuToggle.bind(this));
        document.addEventListener('click', this.backgroundClick.bind(this));

    }

    menuToggle() {
        var computedStyle = window.getComputedStyle(this.navul);
        var displayValue = computedStyle.getPropertyValue('display');

        // const menuHeight = this.openMenu.offsetHeight;

        if (displayValue === 'none') {
            // this.navul.style.top = menuHeight + 'px';
            this.navul.style.display = 'block';


        } else if (displayValue === 'block') {
            this.navul.style.display = 'none';
        }
    }

    backgroundClick(event){
            if (event.target !== this.openMenu) {
                this.navul.style.display = 'none';
            }
    }

}

export default DropdownNav;
